import * as types from '../mutation-types'
import { vuexfireMutations, firebaseAction } from 'vuexfire'
import Maybe from 'data.maybe'
import * as MR from '@/libs/maybe-ramda'
import * as R from 'ramda'
import S from 'sanctuary'
import $ from 'sanctuary-def'
import compareVersions from 'compare-versions'
import { getLocale } from '@/libs/util'
import moment from 'moment-timezone'

export default {
  state: {
    network: true,
    access: null,
    platform: null,
    common: null,
    appConfig: {
      MAX_TAGS,
      WEB_IMAGE_MAX_MB,
      EXCERPT_MAX_SIZE,
      COVER_MAX_SIZE,
      MAX_REVIEW_LENGTH,
      MAX_MEMO_TOTAL_LENGTH,
      MAX_EXCERPTS
    },
    appVersion: process.env.appVersion,
    closingTime: '2022-12-20T00:00:00+09:00',
    noticeTime: '2022-11-15T00:00:00+09:00'
  },
  mutations: {
    [types.NETWORK_SET] (state, network) {
      state.network = network
    },
    [types.PLATFORM_SET] (state, platform) {
      state.platform = platform
    },
    ...vuexfireMutations
  },
  actions: {
    setNetwork ({ commit }, network) {
      commit(types.NETWORK_SET, network)
    },
    setPlatform ({ commit }, platform) {
      commit(types.PLATFORM_SET, platform)
    },
    updateNetwork ({ commit }) {
      const mNonEquals = Maybe.of(R.complement(R.equals))
      const mConnType = MR.of(window.navigator).map(
        R.path(['connection', 'type'])
      )
      const mNONE = MR.of(window.Connection).map(R.prop('NONE'))

      commit(
        types.NETWORK_SET,
        mNonEquals.ap(mConnType).ap(mNONE).getOrElse(true)
      )
    },
    setRef: firebaseAction(({ bindFirebaseRef }, [name, ref]) => {
      return new Promise((resolve, reject) => {
        bindFirebaseRef(name, ref).then(resolve).catch(reject)
      })
    })
  },
  getters: {
    isOffline (state) {
      return !state.network
    },
    appBlocked (state, { user, isAdmin }) {
      const isLevelBlocked = MR.of(state.access)
        .map(R.prop('level'))
        .map(R.equals('blocked'))
        .getOrElse(null)

      return isLevelBlocked === null
        ? null
        : isLevelBlocked && (!user ? true : !isAdmin)
    },
    access (state) {
      return state.access
    },
    platform (state) {
      return state.platform && state.platform.toLowerCase()
    },
    isBrowser (state) {
      return state.platform.toLowerCase() === 'browser'
    },
    isIOS (state) {
      return state.platform.toLowerCase() === 'ios'
    },
    isNative (state, getters) {
      return getters.isAndroid || getters.isIOS
    },
    isAndroid (state) {
      return state.platform.toLowerCase() === 'android'
    },
    maxFreeMemo (state) {
      return MR.of(state.common).chain(MR.prop('maxFreeMemo')).getOrElse(100)
    },
    maxFreeExcerptPerMemo (state) {
      return MR.of(state.common)
        .chain(MR.prop('maxFreeExcerptPerMemo'))
        .getOrElse(2)
    },
    ocrQuotaLimit (state) {
      return MR.of(state.common).chain(MR.prop('ocrQuota')).getOrElse(25)
    },
    isUpdateRequired (state, getters) {
      const latestVersion = S.compose(S.fromMaybe('0'))(
        S.gets(S.is($.String))([getters.platform, 'latestVersion'])
      )

      return compareVersions(state.appVersion, latestVersion(state.common)) < 0
    },
    closingTimeLocale (state) {
      return moment(state.closingTime)
        .tz('Asia/Seoul')
        .locale(getLocale())
        .format('LLL')
    },
    noticeTimeLocale (state) {
      return moment(state.noticeTime)
        .tz('Asia/Seoul')
        .locale(getLocale())
        .format('LL')
    },
    isAfterClosing (state) {
      return moment().isAfter(state.closingTime)
    },
    isAfterNotice (state) {
      return moment().isAfter(state.noticeTime)
    }
  }
}
